<div [class.noShowCarroCompra]="!show" [class.showCarroCompra]="show">
  <app-header></app-header>
  <div class="container">
    <div class="row">
      <div class="col-md pr-24">
        <div class="w-left">
          <app-steppers></app-steppers>
        </div>
      </div>
      <div class="col-md pl-0">
        <div class="w-right">
          <ng-container>
            <app-carro-compra [products]="products$ | async"></app-carro-compra>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <div class="footer">
    <app-footer> </app-footer>
  </div>
</div>